export const DISPENSARY_DEMO_LINK = `https://schedule.dutchie.com/dispensaries/demo`;
export const REFER_A_DISPENSARY_LINK = 'https://try.dutchie.com/dispensary/referral/';
export const RELEASES_LINK = 'https://updates.dutchie.com/';
